(function($) {
    /**
     * Show additional field when 'Sonstige' is selected in dropdown
     */
    $('.form-other').find('select').each(function () {
        toggleFormOther($(this));
    });

    $('.form-other').find('select').on('change', function () {
        toggleFormOther($(this));
    });

    function toggleFormOther(select) {
        var val = select.val();
        var isArray = $.isArray(val);
        var triggerValue = $(select).parents('[data-other-value]').data('other-value');
        triggerValue = String(triggerValue);

        if ((isArray && $.inArray(triggerValue, val) !== -1) || !isArray && val !== null && val.trim() == triggerValue) {
            select.closest('.form-group').next('.form-group').show();
            select.next().removeClass('open');
        } else {
            select.closest('.form-group').next('.form-group').hide();
        }
    }
})(jQuery);
